export const handleLevel2IndexClick = async (
  breadcrumb_info: any,
  siteInfo: any,
  navigate: any
) => {
  if (breadcrumb_info[1].id !== Number(localStorage.clickedId)) {
    localStorage.setItem("sitesTablePage", "0");
  }
  if (siteInfo?.integration_type_name !== "autopatrol") {
    localStorage.setItem(
      "storedSelectedIndex",
      JSON.stringify({
        level1: [Number(breadcrumb_info[0].id)],
        level2: [Number(breadcrumb_info[1].id)],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      })
    );
  } else {
    localStorage.setItem(
      "storedSelectedIndex",
      JSON.stringify({
        level1: [Number(breadcrumb_info[1].id)],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: [],
      })
    );
  }

  localStorage.setItem("siteAboutScrollTop", "0");
  localStorage.setItem("expandedObjectSaved", "false");
  localStorage.setItem("navigatedFromSitesAboutPage", "true");
  localStorage.setItem("level2Click", "true");
  localStorage.setItem("clickedId", JSON.stringify(breadcrumb_info[1].id));
  localStorage.setItem("level1Id", JSON.stringify(breadcrumb_info[0].id));
  localStorage.setItem("level2Id", JSON.stringify(breadcrumb_info[1].id));
  siteInfo?.integration_type_name === "autopatrol"
    ? navigate("/sites_patrol")
    : navigate("/sites");
};
